 <template>
  <div class="container-bg-white">
    <slot name="summary_top"></slot>
    <div class="row p-3">
      <div class="col-12 col-xl-3 mb-2 mb-xl-0">
        <img src="@/assets/images/filter.svg"/>
        <span class="ml-3">{{$t("flexben.general.filter")}}</span>
      </div>
      <div class="col-12 col-md-4 col-xl-3 form-group-multiselect mb-0">
        <label for="partner" class="col-form-label pt-md-0">{{ $t("flexben.voucher_stocks.fields.partner") }}</label>
        <multiselect :multiple="false"
                     :showLabels="false"
                     :class="'from-control'"
                     track-by="value"
                     label="text"
                     id="partner"
                     :closeOnSelect="true"
                     :allow-empty="true"
                     :placeholder="$t('flexben.general.search')"
                     v-model="filtersSpecial.partner"
                     :options="Object.values(filterOptions.partners)"
                     :key="'partner_select'">
          <template slot="noResult">{{$t('flexben.general.no_results_found')}}</template>
        </multiselect>

      </div>
      <div v-if="filterForImport" class="col-12 col-md-4 col-xl-3 form-group mb-0">
        <label for="status" class="col-form-label pt-md-0">{{ $t("flexben.voucher_stocks.fields.status") }}</label>
        <select id="status" v-model="filters.status"
                class="form-control">
          <option v-for="(item,index) of filterOptions.statuses" :value="item" :key="index">{{ $t(statusTransPatch+item)
            }}
          </option>
        </select>
      </div>
      <div v-else class="col-12 col-md-4 col-xl-3 form-group mb-0">
        <label for="status" class="col-form-label pt-md-0">{{ $t("flexben.voucher_stocks.fields.status") }}</label>
        <select id="status" v-model="filters.reconciliation_status"
                class="form-control">
          <option v-for="(item,index) of filterOptions.reconciliation_status" :value="item" :key="index">{{ $t(statusTransPatch+item)
            }}
          </option>
        </select>
      </div>
      <div v-if="!filterForImport" class="col-12 text-center mt-3 mb-2">{{$t("flexben.voucher_stocks.invoicesFields.filterDate")}}
        <font-awesome-icon
          v-if="!filterForImport"
          icon="info-circle"
          class="ml-1 cursor-pointer"
          size="sm"
          v-b-tooltip.hover.top
          :title="$t('flexben.voucher_stocks.invoicesFields.tooltips.filterDateInfo')"
        />
      </div>
      <div v-if="!filterForImport" class="col-12 col-md-6 form-group mb-0">
        <label class="col-form-label" for="request_end_date">{{$t("flexben.voucher_stocks.inputLabels.startDate")}}</label>
        <div class="w-100 d-inline-flex">
          <label for="voucher_created_start_date" class="my-2 mr-2">
            <font-awesome-icon icon="calendar-alt" class="text-24"/>
          </label>
          <vue-datepicker :format="dateFormat"
                          :inputClass="'form-control-d m-0 w-100 background-white'"
                          v-model="filters.purchaseDateFrom"
                          :class="'w-100'"
                          :key="2"
                          @input="filterDate('purchaseDateFrom')"
                          @cleared="filterDate('purchaseDateFrom',true)"
                          id="voucher_created_start_date"></vue-datepicker>
          <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
               @click="filterDate('purchaseDateFrom',true)"/>
        </div>
      </div>
      <div v-if="!filterForImport" class="col-12 col-md-6 form-group mb-0">
        <label class="col-form-label" for="request_end_date">{{$t("flexben.voucher_stocks.inputLabels.endDate")}}</label>
        <div class="w-100 d-inline-flex">
          <label for="voucher_created_end_date" class="my-2 mr-2">
            <font-awesome-icon icon="calendar-alt" class="text-24"/>
          </label>
          <vue-datepicker :format="dateFormat"
                          :inputClass="'form-control-d m-0 w-100 background-white'"
                          v-model="filters.purchaseDateTo"
                          :class="'w-100'"
                          :key="2"
                          @input="filterDate('purchaseDateTo')"
                          @cleared="filterDate('purchaseDateTo',true)"
                          id="voucher_created_start_date"></vue-datepicker>
          <img class="cursor-pointer ml-2" alt="x" src="@/assets/images/flexben/table-remove-button.svg"
               @click="filterDate('purchaseDateTo',true)"/>
        </div>
      </div>
    </div>
    <slot name="summary_bottom"></slot>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment/moment";

export default {
  name: "InvoicesFilters",
  components: {
    'vue-datepicker': Datepicker,
  },
  props: {
    showDateSelectors: {
      type: Boolean,
      default: true,
    },
    filterForImport: {
      type: Boolean,
      default: false,
    },
    filterOptions: {
      type: Object,
      default: () => {
        return {
          partners: [],
          reconciliation_status: [],
          status: [],
          purchaseDateFrom: null,
          purchaseDateTo: null,
        }
      },
      required: true
    },
    filters: {
      type: Object,
      default: () => {
        return {
          partner: null,
          reconciliation_status: 0,
          status: 0,
          search: null,
          purchaseDateFrom: null,
          purchaseDateTo: null,
          per_page: 20,
          page: 1
        }
      },
      required: true
    },
    statusTransPatch: {
      type: String,
      default: "flexben.voucher_stocks.status."
    }
  },
  data() {
    return {
      filtersSpecial: {
        partner: null,
      },
      purchaseDateFrom: null,
      purchaseDateTo: null,
      dateFormat: 'dd/MM/yyyy',
    };
  },
  watch: {
    filtersSpecial: {
      handler: function (v) {
        this.filters.partner = (v.partner !== null) ? v.partner.value : null;
      },
      deep: true
    },
  },
  methods: {
    filterDate(key, clearDate = false) {
      if (clearDate) {
        this.filters[key] = null;
      } else {
        this.filters[key] = this.moment(this.filters[key], 'yyyy-MM-DD');
      }
    },
  }
}
</script>
